import React from 'react';
import styled, { keyframes } from 'styled-components';
import oh from 'output-helpers';
import { MdAssignment, MdDirectionsBus, MdClose } from 'react-icons/md';

class Navbar extends React.Component {
    constructor(props) {
        super(props);

        this.category_width = 120;
        const border_height = 5;

        const anim_bounce_in = keyframes`
            0%{
                opacity: 0;
                transform: scale(0.3) translate3d(0,0,0);
            }
            50%{
                opacity: 0.9;
                transform: scale(1.1);
            }
            80%{
                opacity: 1;
                transform: scale(0.89);
            }
            100%{
                opacity: 1;
                transform: scale(1) translate3d(0,0,0);
            }
        `;

        this.container = styled.div`
            background-color: ${props =>
                props.light
                    ? props.theme.colors.blue[1]
                    : props.theme.colors.dark[0]};
            padding: 0 30px 0;
            color: #fff;
            height: ${props =>
                props.fullHeight
                    ? props.theme.sizes.sub_navbar.extended_height
                    : props.theme.sizes.sub_navbar.height}px;
            ul.categories_container_list {
                overflow: hidden;
                height: ${props =>
                    props.fullHeight
                        ? props.theme.sizes.sub_navbar.extended_height -
                          border_height
                        : props.theme.sizes.sub_navbar.height -
                          border_height}px;
                li {
                    width: ${this.category_width}px;
                    position: relative;
                    height: ${props =>
                        props.fullHeight
                            ? props.theme.sizes.sub_navbar.extended_height -
                              border_height
                            : props.theme.sizes.sub_navbar.height -
                              border_height}px;
                    cursor: pointer;
                    padding: ${props => (props.steps ? '0 0 10px' : '20px 0')};
                    float: left;
                    font-size: 16px;
                    text-align: center;
                    opacity: 0.5;
                    font-weight: 400;
                    transition: all 0.3s;
                    &:hover {
                        opacity: 1;
                    }
                    &.active {
                        opacity: 1;
                        font-weight: bold;
                        .navbar_step {
                            animation: ${anim_bounce_in} 0.6s;
                            background-color: ${props =>
                                props.theme.colors.blue[1]};
                            color: #fff;
                        }
                    }
                    &.updated {
                        color: ${props => props.theme.colors.red[2]};
                        opacity: 1;
                        font-weight: bold;
                        &:hover {
                            color: ${props => props.theme.colors.red[1]};
                        }
                        .updated_indicator {
                            background-color: ${props =>
                                props.theme.colors.red[1]};
                            margin-right: 4px;
                            display: inline-block;
                            margin-bottom: 2px;
                        }
                    }
                    .updated_indicator {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        display: none;
                    }
                }
            }
            .message_count {
                position: absolute;
                min-width: 20px;
                height: 20px;
                padding: 5px;
                border-radius: 10px;
                justify-content: center;
                align-items: center;
                display: flex;
                text-align: center;
                background-color: ${props => props.theme.colors.red[0]};
                right: 0;
                top: 0;
            }
            .border_container {
                height: ${border_height}px;
                width: ${this.category_width *
                    (props.categories_with_message_count
                        ? props.categories_with_message_count.length
                        : 0)}px;
                position: relative;
            }
            .navbar_left,
            .navbar_right {
                display: inline-block;
                vertical-align: middle;
            }
            .navbar_right {
                float: right;
            }
            .action_button {
                cursor: pointer;
                border: 1px solid ${props => props.theme.colors.red[0]};
                background-color: ${props => props.theme.colors.red[1]};
                padding: 12px 32px;
                color: #fff;
                border-radius: 4px;
                font-size: 14px;
                font-weight: bold;
                transition: all 0.3s;
                &:hover {
                    background-color: ${props => props.theme.colors.red[2]};
                }
            }
            .navbar_step {
                margin: 15px auto;
                border-radius: 50%;
                width: 50px;
                height: 50px;
                background-color: #fff;
                font-size: 20px;
                font-weight: bold;
                display: table;
                text-align: center;
                color: ${props => props.theme.colors.dark[0]};
                transition: all 0.3s;
                p {
                    display: table-cell;
                    vertical-align: middle;
                }
            }
            .navbar_icon,
            .navbar_big_title {
                display: inline-block;
                vertical-align: middle;
            }
            .navbar_icon {
                svg {
                    width: 42px;
                    height: 42px;
                    margin-right: 12px;
                }
            }
            .navbar_big_title {
                font-weight: bold;
                font-size: 28px;
                padding: 20px 0;
                span {
                    font-size: 16px;
                    opacity: 0.85;
                    margin-left: 8px;
                }
            }
            .close_button {
                position: relative;
                right: 0;
                top: 0;
                border: none;
                height: 52px;
                width: 52px;
                background-color: rgba(0, 0, 0, 0.1);
                color: #fff;
                cursor: pointer;
                &:hover {
                    background-color: rgba(0, 0, 0, 0.4);
                }
                svg {
                    fill: #fff;
                    width: 28px;
                    height: 28px;
                }
            }
        `;

        this.border_item = styled.div`
            transition: left 0.3s, background-color 0.6s;
            position: absolute;
            top: 0;
            left: 0;
            height: ${border_height}px;
            width: ${this.category_width}px;
            border-radius: 4px 4px 0 0;
            background-color: ${props =>
                props.light
                    ? '#fff'
                    : props.theme.colors.states[props.state]
                    ? props.theme.colors.states[props.state]
                    : props.theme.colors.blue[2]};
            &.item_0 {
                background-color: ${props => props.theme.colors.blue[2]};
            }
            &.item_1 {
                background-color: ${props => props.theme.colors.red[2]};
            }
            &.item_2 {
                background-color: ${props => props.theme.colors.green[2]};
            }
            &.item_3 {
                background-color: ${props => props.theme.colors.green[0]};
            }
        `;
    }

    renderIcon() {
        if (!this.props.icon) {
            return null;
        }
        switch (this.props.icon) {
            case 'order':
                return (
                    <div className="navbar_icon">
                        <MdAssignment />
                    </div>
                );
            case 'entity':
                return (
                    <div className="navbar_icon">
                        <MdDirectionsBus />
                    </div>
                );
            default:
                return null;
        }
    }

    renderBigTitle() {
        if (!this.props.bigTitle) {
            return null;
        }
        return (
            <p className="navbar_big_title">
                {this.props.bigTitle}
                {this.props.subtitle ? (
                    <span>{this.props.subtitle}</span>
                ) : null}
            </p>
        );
    }

    renderCategories() {
        if (
            !this.props.categories_with_message_count ||
            this.props.categories_with_message_count.length < 1
        ) {
            return null;
        }
        return (
            <div className="categories_container">
                <ul className="categories_container_list">
                    {this.props.categories_with_message_count.map((item, i) => {
                        let li_classes = item.classes || [];
                        if (i === this.props.selected_category) {
                            li_classes.push('active');
                        }
                        return (
                            <li
                                key={i}
                                className={
                                    li_classes.length === 0
                                        ? null
                                        : li_classes.join(' ')
                                }
                                onClick={() => {
                                    item.onClick();
                                }}
                            >
                                {this.props.steps ? (
                                    <div className="navbar_step">
                                        <p>{i + 1}</p>
                                    </div>
                                ) : null}
                                <div>
                                    {oh.translate(item.name)}
                                </div>
                                { item.messages_count > 0 &&
                                    <div className={'message_count'}>
                                        {item.messages_count}
                                    </div>
                                }
                            </li>
                        );
                    })}
                </ul>
                {this.props.border ? (
                    <div className="border_container">
                        <this.border_item
                            light={this.props.light}
                            state={this.props.selected_category}
                            className={`border_item`}
                            style={{
                                left:
                                    this.category_width *
                                        this.props.selected_category +
                                    'px',
                            }}
                        ></this.border_item>
                    </div>
                ) : null}
            </div>
        );
    }

    renderActionButton() {
        if (!this.props.action_button) {
            return null;
        }
        return (
            <div className="navbar_right">
                <button
                    className="action_button"
                    onClick={() => this.props.action_button.onClick()}
                >
                    {this.props.action_button.label}
                </button>
            </div>
        );
    }

    renderClose() {
        if (!this.props.close) {
            return null;
        }
        return (
            <div className="navbar_right">
                <button
                    className="close_button"
                    onClick={() => this.props.close()}
                >
                    <MdClose />
                </button>
            </div>
        );
    }

    render() {
        return (
            <this.container
                light={this.props.light}
                fullHeight={this.props.fullHeight}
                steps={this.props.steps}
            >
                <div className="navbar_left">
                    {this.renderIcon()}
                    {this.renderBigTitle()}
                    {this.renderCategories()}
                </div>
                {this.renderClose()}
                {this.renderActionButton()}
                {this.props.children}
            </this.container>
        );
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/base/Navbar.jsx